import { EditorUtils, IntegerEditor, StringEditor, TextAreaEditor } from "@serenity-is/corelib";
import { alertDialog, confirmDialog, getCookie, isEmptyOrNull, notifyError, notifySuccess, resolveUrl, serviceCall } from "@serenity-is/corelib/q";
import { isNumeric } from "jquery";
import { userDefinition } from "../../../Administration/User/Authentication/Authorization";
import { DateMaskEditor } from "../../../Common/Editors/DateMaskEditor";
import { Utils } from "../../../Common/Helpers/Utils";
import { WarrantyPublicResponse } from "../../../ServerTypes/Warranty";
import { WarrantyPublicEndPointService } from "../../../ServerTypes/Warranty/Public.WarrantyPublicEndPointService";
import { WarrantyRequestPartGrid } from "../../WarrantyRequestPart/WarrantyRequestPartGrid";
$(function () {
    new WarrantyRequestService();
});
export class WarrantyRequestService {
    constructor() {
        var serialNumberEditor = new StringEditor($('#serialNumber'));
        var callerEditor = new StringEditor($('#caller'));
        var dealerEditor = new StringEditor($('#dealer'));
        var customerNameEditor = new StringEditor($('#customerName'));
        var dateProblemReportedEditor = new DateMaskEditor($('#dateProblemReported'), { alias: 'mm/dd/yyyy' });
        var modelEditor = new StringEditor($('#model'));
        //var dateProblemRepairedEditor = new DateMaskEditor($('#dateProblemRepaired'), { alias: 'mm/dd/yyyy' });
        var warrantyRegistrationDateEditor = new DateMaskEditor($('#warrantyRegistrationDate'), { alias: 'mm/dd/yyyy' });
        var problemDescriptionEditor = new TextAreaEditor($('#problemDescription'), { rows: 3 });
        var actionsTakenEditor = new TextAreaEditor($('#actionsTaken'), { rows: 3 });
        var callbackNumberEditor = new StringEditor($('#callbackNumber'));
        //var actionRecommendedEditor = new TextAreaEditor($('#actionRecommended'), { rows: 3 });
        //var actionTakenEditor = new TextAreaEditor($('#actionTaken'), { rows: 3 });
        var emailEditor = new StringEditor($('#email'));
        var titleEditor = new StringEditor($('#title'));

        var laborHours = new IntegerEditor($("#laborHours"));

        var formData = new FormData();
        const fileInput = document.getElementById("fileInput") as HTMLInputElement;
        const uploadedList = document.getElementById("uploadedList") as HTMLUListElement;

        var today = new Date();
        dateProblemReportedEditor.element.datepicker("option", "maxDate", today);

        var partGrid = new WarrantyRequestPartGrid($('#warrantyRequestpartGrid'));

        EditorUtils.setReadOnly(dealerEditor, true);
        EditorUtils.setReadOnly(customerNameEditor, true);
        EditorUtils.setReadOnly(modelEditor, true);
        EditorUtils.setReadOnly(warrantyRegistrationDateEditor, true);
        serialNumberEditor.element.focus();

        serialNumberEditor.change(e => {
            if (!isEmptyOrNull(serialNumberEditor.value)) {
                WarrantyPublicEndPointService.CheckSerialNumber({
                    SerialNumber: serialNumberEditor.value,
                    RequestType: 1
                }, response => {
                    if (!response.IsSuccess) {
                        notifyError(response.Message);
                        dealerEditor.value = null;
                        customerNameEditor.value = null;
                        warrantyRegistrationDateEditor.value = null;
                        modelEditor.value = null;
                        serialNumberEditor.element.focus();
                    }
                    //else {
                    //    if (response.IsRegistered && !response.IsExpired) {
                    //        dealerEditor.value = response.Entity.CustomerName;
                    //        customerNameEditor.value = response.Entity.UName;
                    //        warrantyRegistrationDateEditor.value = response.RegistrationDate;
                    //        modelEditor.value = response.Entity.ChassisModel;
                    //        problemDescriptionEditor.element.focus();
                    //    }
                    //    else if (!response.IsRegistered) {
                    //        let registerUrl = window.location.origin + "/Warranty/Registration";
                    //        let alertHtml = `
                    //            <div class="alert alert-danger centerValidateAlert alert-dismissible fade show" role="alert">
                    //                <h4 class="alert-heading">Warranty Not Found</h4>
                    //                <hr>
                    //                <h3><p><strong>Please Register Your Unit</strong></p></h3>
                    //                <p>We are sorry but this unit is not registered with the warranty system.
                    //                Please follow this link to complete a warranty registration or contact
                    //                Curtbender Service at <a href="mailto:service@curtbender.com">service@curtbender.com</a>
                    //                or call extension 410.</p>
                    //                <a href="${registerUrl}" class="alert-link" style="float: right;">Register Warranty</a>

                    //                <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                    //            </div>
                    //        `;

                    //        $("#alert-container").html(alertHtml);
                    //        resetForm();
                    //    }
                    //    else if (response.IsExpired) {
                    //        let alertHtml = `
                    //            <div class="alert alert-danger centerValidateAlert alert-dismissible fade show" role="alert">
                    //                <h4 class="alert-heading">Unit out of warranty</h4>
                    //                <hr>
                    //                <h3><p><strong>Contact Curtbender</strong></p></h3>
                    //                <p>
                    //                    This unit is out of warranty. Please contact Curtbender Service at
                    //                    <a href="mailto:service@curtbender.com">service@curtbender.com</a>
                    //                    or call extension 410.
                    //                </p>
                    //                <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                    //            </div>
                    //        `;

                    //        $("#alert-container").html(alertHtml);
                    //        resetForm();
                    //    }
                    //}
                    else {
                        // Populate form from unit info regardless of warranty/registration status
                        dealerEditor.value = response.Entity.CustomerName;
                        customerNameEditor.value = response.Entity.UName;
                        warrantyRegistrationDateEditor.value = response.RegistrationDate ?? null;
                        modelEditor.value = response.Entity.ChassisModel;
                        problemDescriptionEditor.element.focus();
                    }
                });
            } else {
                resetForm();
            }
        });

        $('input[type=text], textarea').change(e => {
            let el = $(e.target);
            el.parent().find('label.error').hide();
            el.removeClass('error');
            if (isEmptyOrNull(el.val())) {
                el.addClass('error');
                el.parent().find('label.error').show();
            }
        });

        emailEditor.change(e => {
            let el = $(e.target);
            el.parent().find('label.error').hide();
            el.removeClass('error');
            if (isEmptyOrNull(emailEditor.value)) {
                emailEditor.element.addClass('error');
                emailEditor.element.parent().find('label.error').show().text('This field is required.').attr('title', 'This field is required.');
            } else {
                if (!Utils.String.validateEmail(emailEditor.value)) {
                    emailEditor.element.addClass('error');
                    emailEditor.element.parent().find('label.error').show().text('Email is not valid').attr('title', 'Email is not valid');
                    emailEditor.element.focus();
                }
            }
        });

        fileInput.addEventListener("change", async () => {

            if (!fileInput.files) return;
            const allowedMime = [
                "application/pdf",
                "image/jpeg",
                "image/png",
                "image/gif"
            ];

            let files = Array.from(fileInput.files);
            var dt = new DataTransfer();

            var isValid = true;
            for (let file of files) {
                let ext = file.name.split(".").pop().toLowerCase();
                var validMime = allowedMime.indexOf(file.type) !== -1;

                if (validMime) {
                    dt.items.add(file);
                }
                else {
                    notifyError("Invalid file type: " + file.name + ". File content does not match allowed types.");
                }
            }
            if (dt.files.length == 0) {
                fileInput.value = "";
                return;
            }

            Array.from(dt.files).forEach(f => formData.append("files", f));
            renderFileList();
        });


        $('button#warranty-request-service-button').click(e => {
            $('label.error').hide();
            $('.fd-error').hide();
            $('input.error').removeClass('error');
            var isError = false;
            if (isEmptyOrNull(serialNumberEditor.value)) {
                isError = true;
                serialNumberEditor.element.addClass('error');
                serialNumberEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(dateProblemReportedEditor.value)) {
                isError = true;
                dateProblemReportedEditor.element.addClass('error');
                dateProblemReportedEditor.element.parent().find('.required-error').show();
            }
            if (dateProblemReportedEditor.valueAsDate > today) {
                isError = true;
                dateProblemReportedEditor.element.addClass('error');
                notifyError("The date can't be a future date.");
                $('.fd-error').show();
            }
            if (isEmptyOrNull(problemDescriptionEditor.value)) {
                isError = true;
                problemDescriptionEditor.element.addClass('error');
                problemDescriptionEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(emailEditor.value)) {
                isError = true;
                emailEditor.element.addClass('error');
                emailEditor.element.parent().find('label.error').show().text('This field is required.').attr('title', 'This field is required.');
            } else {
                if (!Utils.String.validateEmail(emailEditor.value)) {
                    isError = true;
                    emailEditor.element.addClass('error');
                    emailEditor.element.parent().find('label.error').show().text('Email is not valid').attr('title', 'Email is not valid');
                    emailEditor.element.focus();
                }
            }
            if (isEmptyOrNull(callbackNumberEditor.value)) {
                isError = true;
                callbackNumberEditor.element.addClass('error');
                callbackNumberEditor.element.parent().find('label.error').show();
            }
            else {
                if (!/^\d{3}-\d{3}-\d{4}$/.test(callbackNumberEditor.value)) {
                    isError = true;
                    callbackNumberEditor.element.addClass('error');
                    callbackNumberEditor.element.parent().find('label.error').show().text('Callback number should always be 12 characters ###-###-####').attr('title', 'Callback number should always be 12 characters ###-###-####');
                    callbackNumberEditor.element.focus();
                }
            }
            if (isError) {
                return;
            }

            confirmDialog(`Are you sure you want to Submit?`, () => {
                var wrParts = partGrid.getItems();
                if (wrParts.length > 0 && !partGrid.isValidWRPartList(wrParts)) return;

                $('.btn').attr('disabled', 'disabled');
                $('.btn').addClass('disabled');

                WarrantyPublicEndPointService.RequestWarranty({
                    Entity: {
                        Caller: callerEditor.value,
                        SerialNo: serialNumberEditor.value,
                        DateOfFailure: dateProblemReportedEditor.value,
                        //DateOfRepair: dateProblemRepairedEditor.value,
                        Complaint: problemDescriptionEditor.value,
                        Correction: actionsTakenEditor.value,
                        //ActionRequest: actionRecommendedEditor.value,
                        //ActionTaken: actionTakenEditor.value,
                        Title: titleEditor.value,
                        Email: emailEditor.value,
                        DealerPhone: callbackNumberEditor.value,
                        IssueStatus: 3,
                        CallbackNumber: callbackNumberEditor.value,
                        LaborHours: laborHours.value
                    },
                    Parts: wrParts,
                    Username: userDefinition().Username,
                    DistributorName: dealerEditor.value,
                    CustomerName: customerNameEditor.value,
                    ProductModel: modelEditor.value
                }, response => {
                    $('.btn').removeAttr('disabled');
                    $('.btn').removeClass('disabled');
                    if (!response.IsSuccess) {
                        notifyError(response.Message);
                    } else {
                        //window.location.href = `${window.location.origin}/Warranty/RequestSuccess`;
                        let html = createSrAlert({
                            srNumber: response.Sr,
                            distributor: dealerEditor.value,
                            customer: customerNameEditor.value,
                            model: modelEditor.value,
                            serial: serialNumberEditor.value,
                            tech: callerEditor.value,
                            title: titleEditor.value,
                            email: emailEditor.value,
                            callback: callbackNumberEditor.value
                        });

                        const files = formData.getAll("files") as File[];
                        if (files.length === 0) {
                            $("input,textarea").val("");
                            partGrid.setItems([]);
                            partGrid.pendingChanges = {};
                            partGrid.removeList = [];
                            partGrid.refresh();
                            $("#response-alert").html(html);
                        }
                        else {
                            // WI 36742. This used to post to /Upload/UploadFiles, which requires the staff
                            // permission Warranty:ServiceReportPn:Read - so for a visitor with no account
                            // it always failed and the invoices were lost while the service request itself
                            // was created. It now posts to the public route, which is authorised by the
                            // token minted with this response and can only write to this service request.
                            // The Sr is deliberately NOT sent: the server takes it from the token.
                            const _formData = new FormData();
                            _formData.append("token", response.InvoiceUploadToken);
                            Array.from(files).forEach(f => _formData.append("files", f));
                            $.ajax({
                                url: '/Warranty/Public/UploadInvoices',
                                type: 'POST',
                                data: _formData,
                                processData: false,
                                contentType: false,
                                // The application registers AutoValidateAntiforgery globally, and a raw
                                // $.ajax sends no antiforgery header - Serenity only adds it inside its own
                                // serviceCall. Without this the POST is refused with an empty-bodied 400
                                // before it reaches any of our code, which is the second half of why this
                                // upload never worked: the staff permission stopped it, and so did this.
                                // The cookie is issued to the page by AntiforgeryCookieResultFilter.
                                headers: { 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN') },
                                success: function (res) {
                                    $("input,textarea").val("");
                                    partGrid.setItems([]);
                                    partGrid.pendingChanges = {};
                                    partGrid.removeList = [];
                                    partGrid.refresh();

                                    formData = new FormData();
                                    $("#uploadedList").children().remove();

                                    $("#response-alert").html(html);
                                },
                                error: function (xhr) {
                                    // The service request exists either way, so the message has to say so -
                                    // the old "Upload failed." left the submitter unsure whether to send it
                                    // again. The server explains which file it refused and why.
                                    const reason = xhr?.responseJSON?.message
                                        || "The attachments could not be stored.";
                                    notifyError("Service request " + response.Sr + " was created, but the "
                                        + "attachments were not stored. " + reason
                                        + " Please email them quoting " + response.Sr + ".");
                                    $("#response-alert").html(html);
                                }
                            });
                        }
                    }
                });
            }, {
                title: 'Confirm Submit',
                dialogClass: 's-MessageDialog s-WarningDialog'
            });
        });

        function createSrAlert(data) {
            // Logged-in users get a way back to their dashboard (Phase 1's routing sorts out
            // which one) - not an auto-redirect, since the SR# here is critical reference info
            // an anonymous submitter especially needs time to read before leaving the page.
            const isLoggedIn = !!userDefinition().Username;
            const dashboardLink = isLoggedIn
                ? `<a href="${resolveUrl('~/')}" class="btn btn-primary btn-sm mt-2">Go to your dashboard</a>`
                : '';
            return `
                <div class="alert alert-success centerAlert alert-dismissible fade show" role="alert">
                    <h4 class="alert-heading"><strong>SR Submitted Successfully</strong></h4>
                    <p><h3><strong>SR# ${data.srNumber}</strong></h3></p>

                    <p><strong>Critical Information</strong></p>
                    <ul>
                        <li>${data.distributor}</li>
                        <li>${data.customer}</li>
                        <li>${data.model}</li>
                        <li>${data.serial}</li>
                        <li>${data.tech}</li>
                        <li>${data.title}</li>
                        <li>${data.email}</li>
                        <li>${data.callback}</li>
                    </ul>
                    ${dashboardLink}

                    <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                </div>
            `;
        }

        function resetForm() {
            dealerEditor.value = null;
            customerNameEditor.value = null;
            warrantyRegistrationDateEditor.value = null;
            modelEditor.value = null;
            serialNumberEditor.element.focus();

            formData = new FormData();
            $("#uploadedList").children().remove();
        }

        function renderFileList() {
            uploadedList.innerHTML = "";

            const files = formData.getAll("files") as File[];

            files.forEach((file: File, index: number) => {
                const li = document.createElement("li");
                li.className = "list-group-item d-flex justify-content-between align-items-center";

                li.innerHTML = `
                <span>${file.name} (${formatFileSize(file.size)})</span>
                <button class="btn btn-danger btn-sm" data-index="${index}">
                    <i class="fa fa-trash"></i>
                </button>
            `;

                uploadedList.appendChild(li);
            });
            fileInput.value = "";

            attachDeleteEvents();
        }

        function formatFileSize(bytes: number): string {
            if (bytes === 0) return "0 Bytes";
            const k = 1024;
            const sizes = ["Bytes", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        }

        function attachDeleteEvents() {
            const buttons = uploadedList.querySelectorAll("button[data-index]");

            buttons.forEach(button => {
                button.addEventListener("click", () => {
                    const index = Number((button as HTMLButtonElement).dataset.index);
                    deleteFile(index);
                });
            });
        }

        function deleteFile(index: number) {
            const files = formData.getAll("files") as File[];

            // Remove file at index
            files.splice(index, 1);

            // Rebuild FormData
            formData = new FormData();
            files.forEach(f => formData.append("files", f));

            renderFileList();
        }
    }
}